(function($) {
	$(document).ready(function() {
 		$('form#news-search-form').on( 'submit', function( ev ) {
			ev.preventDefault();
			newsForm();
		})
		$('form#news-search-form select[name="category"]').on('change', function() {
			$('form#news-search-form input[type="text"]').val('');
			newsForm();
		})
		$('form#news-search-form select[name="year"]').on('change', function() {
			$('form#news-search-form input[type="text"]').val('');
			newsForm();
		})

		$('.page-pagination ul.page-numbers > a').on('click', function(ev) {
			ev.preventDefault();
		});

		$(document).on( 'submit', '.section-news form#search-fails', function( ev ) {
			ev.preventDefault();
			newsForm();
		});


		$(document).on('click', '.page-pagination ul.page-numbers li', function(ev) {
			ev.preventDefault();
			ev.stopPropagation();
			var paginationController = $(this).find('.ajaxPage');
			
			var pageNum = '';
			if(paginationController.html() == '>') {

			} else if(paginationController.html() == '<') {

			} else {
				var pageNum = parseInt(paginationController.html());
			}
			newsForm(pageNum);
		})




 		function newsForm(page) {
 			var searchTerm = $("#news-search-form input[name='s']").val();
 			var yearArchive = $("#news-search-form select[name='year'] option:selected").val();
 			var categoryArchive = $("#news-search-form select[name='category'] option:selected").val();

 			var pagination = page;
 			if(pagination == undefined) {
 				pagination = 1;
 			}


 			var newsSearchFail = $('.section-news form#search-fails #failSearch').val();
 			if((newsSearchFail != undefined) && (newsSearchFail.length > 0)) {
 				searchTerm = newsSearchFail;
 				yearArchive = '';
 				categoryArchive = '';
 			}

			$.ajax({
				url: news_search.ajaxurl,
				type: 'post',
				data: {
					action: 'news_search',
					searchTerm : searchTerm,
					yearArchive : yearArchive,
					categoryArchive : categoryArchive,
					pageNumber : pagination,
				},
				beforeSend: function() {
					$('.section-news .container .page-pagination').remove();
					$('.section-news .container .loop-posts').remove();
					$('.section-news #search-fails').remove();
				},
				success: function( result ) {
					$('.section-news .container').append(result);
					var loop_posts = document.querySelectorAll('.loop-posts .posts-container');
					if(loop_posts.length > 0) {
						sameHeight(loop_posts, 768);
					}


					/* PAGINATION */
					var data = $('.page-pagination').data('page');
					$('.page-pagination ul li span.ajaxPage').each(function() {
						if($(this).text() == data) {
							$(this).addClass('active');
						}
					});

					var news_top = $('.filter-news').offset().top + $('.filter-news').outerHeight();
					$('html, body').animate({
				        scrollTop: news_top,
				    }, 1000);

				}
			})
 		}

	});  
})(jQuery);